import src from "IMAGE";
export default { src, width: 24, height: 24, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAASElEQVR42pXOuwkAIRBFUcOtZgsw8NOEIhYiCIKZlu0NDEfBgZNdmKfUw/1I+E6BQUWGk4KAgQ5/CiYarBRoFMT9ThwZbyPFW5FeBu4UmQFDAAAAAElFTkSuQmCC"};
